import React from 'react';
import MessageBtn from './MessageBtn';

const FollowBody = ({ item }) => {
    const { Sno, fDate, fTime, remarks } = item;
    return (
        <tbody>
            <tr className="border-b hover:bg-gray-100 animation">
                <td className="table_body border-r">
                    {Sno}
                </td>
                <td className="table_body border-r">
                    {fDate}
                </td>
                <td className="table_body border-r">
                    {fTime}
                </td>
                <td className="table_body border-r">
                    {remarks}
                </td>
                <td className="table_body border-r">
                    <MessageBtn />
                </td>
            </tr>
        </tbody>
    )
}

export default FollowBody;